import { useParams } from 'react-router-dom';

/**
 * Hook to get the current community ID from URL parameters
 * @returns The community ID from the current URL, or undefined if not present
 */
export function useCurrentCommunityId(): string | undefined {
  const { communityId } = useParams<{ communityId: string }>();

  return communityId;
}
